import React, { Component, PureComponent } from 'react'
import PageHeaderWrapper from '../../../../components/PageHeaderWrapper'

import { FormUtils as GetAllFormFields } from 'sz-react-utils'
import Exception from '../../../../components/Exception'
import StudentInfo from '../../../../components/StudentInfo'

import moment from 'moment'
import { Button, Card, Col, Form, Input, InputNumber, notification, Row, Select, Table, Tabs, Tooltip } from 'antd'
import _ from 'lodash'

import { hideLoader } from '../../../../modules/actions'
import Request from '../../../../request'
import { connect } from 'react-redux'
import styles from '../../../Desk/registration/all/styles.less'
import StudentHeader from '../../../../components/studentHeader'

const Option = Select.Option
const TabPane = Tabs.TabPane
const config = {
    rules: [{ type: 'object', required: true, message: 'Please select time!' }]
}


let inputTypes1 = {
    fields: [
        { label: 'Mother\'s Name', key: 'motherName', required: true },
        { label: 'Mother\'s Occupation', key: 'motherOccupation', required: true },
        {
            label: 'Mother\'s Contact Number',
            key: 'motherContactNumber',
            required: true
        },
        {
            label: 'Mother\'s Annual Income',
            key: 'motherAnnualIncome',
            required: true
        },
        { label: 'Visa Subclass', key: 'visaSubClasses', required: true }
    ]
}
let tutionFields = {
    fields: [
        { label: 'Draft/TT Issue Date', key: 'draftDate', type: 'date', required: true },
        { label: 'Bank Name', key: 'bankName', required: true },
        { label: 'Total Amount of TT', key: 'draftAmount', required: true },
        { label: 'Name of Institute', key: 'institute', required: true },
        {
            label: 'Amount of Tution Fee',
            key: 'amountOfTutionFee',
            type: 'number',
            required: true
        },
        { label: 'Balance', key: 'balance', type: 'number', required: true }
    ]
}
let tutionFields1 = {
    fields: [
        { label: 'Document Name ', key: 'documentName', required: true },
        {
            label: 'Description',
            key: 'description',
            type: 'textArea',
            rows: 5,
            required: true
        },
        { label: 'Select a file to upload', key: 'files', type: 'file' }
    ]
}

class DIV extends Component {
    render() {
        return (<div>{this.props.children}</div>)
    }
}


@Form.create()
class FormComp extends Component {

    state = {
        hideForm: false

    }
    handleSubmit = e => {
        const { dispatch, form } = this.props
        e.preventDefault()

        form.validateFieldsAndScroll(async (err, valData) => {

            if (!err) {
                let values = _.clone(valData)
                let familyObj = {
                    _id: this.props.inquiryId,
                    // _id: '5c80ab2b632e9e361247487e',
                    family: { ...values }
                }
                let x = await Request.addFamilyAndFinance({ ...familyObj })

                // dispatch(hideLoader())

                if (!x.error) {
                    notification.success({
                        message: 'Success',
                        description: x.msg
                    })

                    // this.props.form.resetFields()
                } else {
                    notification.error({
                        message: 'Error Saving',
                        description: x.msg
                    })
                }

            }
        })
    }

    async componentDidMount() {
        const {
            data, form: { getFieldDecorator, getFieldValue, setFieldsValues }, inquiryId
        } = this.props
        const { dispatch, form } = this.props

        let { doc } = await Request.getInquiry(inquiryId)


        if (doc && doc.family) {
            form.setFieldsValue({
                fatherName: doc.family.fatherName,
                fatherOccupation: doc.family.fatherOccupation,
                fatherAnnualIncome: doc.family.fatherAnnualIncome,
                fatherContactNumber: doc.family.fatherContactNumber,
                motherName: doc.family.motherName,
                motherOccupation: doc.family.motherOccupation,
                motherContactNumber: doc.family.motherContactNumber,
                motherAnnualIncome: doc.family.motherAnnualIncome,
                familyAccompanying: doc.family.familyAccompanying,
                visaSubClasses: doc.family.visaSubClasses,
                currencyValue: doc.family.currencyValue
            })

            this.props.getCurrenyValue(doc.family.currencyValue || 1)


        }


    }

    render() {
        const {
            form: { getFieldDecorator, getFieldValue, setFieldsValue }
        } = this.props


        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 8 },
                md: { span: 8 }
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 16 },
                md: { span: 12 }
            }
        }
        const submitFormLayout = {
            wrapperCol: {
                xs: { span: 24, offset: 0 },
                sm: { span: 10, offset: 7 },
                md: { span: 12, offset: 8 }
            }
        }

        let inputTypes = {
            fields: [
                { label: 'Father\'s Name', key: 'fatherName', required: true },
                { label: 'Father\'s Occupation', key: 'fatherOccupation', required: true },
                { label: 'Father\'s Contact', key: 'fatherContactNumber', required: true },
                {
                    label: 'Father\'s Annual Income',
                    key: 'fatherAnnualIncome',
                    required: true
                },
                // {label: 'Father Accompanying', key: 'familyAccompanying', required: true},
                {
                    label: 'Currency Value',
                    key: 'currencyValue',
                    type: 'number',
                    required: true,
                    onChange: (val) => {
                        setFieldsValue({
                            currencyValue: val
                        })
                        this.props.getCurrenyValue(val)
                    }
                }
            ]
        }

        return (
            <Form onSubmit={this.handleSubmit} style={{ marginTop: 8 }}>

                <div>
                    <Row>
                        <Col span={12}>
                            <GetAllFormFields
                                inputSchema={inputTypes}
                                refresh={this.refreshFxn}
                                getFieldDecorator={getFieldDecorator}
                            />
                        </Col>
                        <Col span={12}>
                            <GetAllFormFields
                                inputSchema={inputTypes1}
                                refresh={this.refreshFxn}
                                getFieldDecorator={getFieldDecorator}
                            />
                        </Col>
                    </Row>
                </div>

                <Button
                    type="primary"
                    htmlType="submit"
                    style={{
                        marginBottom: 10,
                        marginLeft: '33%',
                        backgroundColor: 'green'
                    }}
                    loading={this.props.loading}>
                    SAVE FAMILY DETAILS
                </Button>
            </Form>
        )
    }
}

@Form.create()
class GridForm extends Component {

    state = {
        currencyValue: 1,
        finacialGrid: []
    }

    handleSubmit = e => {
        const { dispatch, form } = this.props
        const { finacialGrid } = this.state
        e.preventDefault()

        form.validateFieldsAndScroll(async (err, valData) => {
            if (!err) {
                let values = _.clone(valData)
                this.state.finacialGrid.push(values)
                this.state.finacialdocument.push(values)

                form.resetFields()
            }
        })
    }
    save = async () => {

        const { finacialGrid, finacialdocument } = this.state

        let familyObj = {
            _id: this.props.inquiryId,
            finacial: {
                finacialGrid: finacialdocument
            }
        }
        let x = await Request.addFamilyAndFinance({ ...familyObj })


        if (!x.error) {
            notification.success({
                message: 'Success',
                description: x.msg
            })

            // this.props.form.resetFields()
        } else {
            notification.error({
                message: 'Error Saving',
                description: x.msg
            })
        }

    }

    componentWillReceiveProps(nextProps, nextContext) {
        if (nextProps.currencyValue) {
            this.setState({
                currencyValue: nextProps.currencyValue
            })
        }

        if (nextProps.finacialGrid) {
            this.setState({
                finacialGrid: nextProps.finacialGrid
            })
        }
    }

    async componentDidMount() {
        const {
            data, form: { getFieldDecorator, getFieldValue, setFieldsValues }, inquiryId
        } = this.props
        const { dispatch, form } = this.props
        let { doc } = await Request.getInquiry(inquiryId)
        if (doc && doc.finacial && doc.finacial.finacialGrid) {
            this.setState({ finacialdocument: doc.finacial.finacialGrid })

        }
    }

    render() {


        const { currencyValue, finacialGrid, finacialdocument } = this.state
        const {

            form: { getFieldDecorator, getFieldValue, setFieldsValue }
        } = this.props

        const tableColumns = [
            {
                title: 'Sponsors Name',
                key: 'sponser',
                dataIndex: 'sponser'
            },
            {
                title: 'Relationship',
                key: 'relationship',
                dataIndex: 'relationship'
            },

            {
                title: 'Bank/Financial Institute ',
                key: 'bank',
                dataIndex: 'bank'
            },

            {
                title: 'Banks Phone No ',
                key: 'bankPhone',
                dataIndex: 'bankPhone'
            },
            {
                title: 'Account Type ',
                key: 'acType',
                dataIndex: 'acType'
            },
            {
                title: 'Account No ',
                key: 'acNo',
                dataIndex: 'acNo'
            },
            {
                title: 'Balance (Rs.)',
                key: 'balanceRs',
                dataIndex: 'balanceRs'


            },
            // {
            //     title: 'Balance ($) ',
            //     key: 'balanceDollar',
            //     dataIndex: 'balanceDollar'
            // },
            {
                title: 'Annual Income(Rs.) ',
                key: 'annualRs',
                dataIndex: 'annualRs'
            },
            // {
            //     title: 'Annual Income($) ',
            //     key: 'annualDollar',
            //     dataIndex: 'annualDollar'
            // },
            {
                title: 'Action',
                key: 'operation',
                icon: 'trash',

                render: (val, record) => (
                    <React.Fragment>
                        <Tooltip title="Delete">
                            <Button
                                shape="circle"
                                onClick={() => {
                                    let tt = this.state.finacialdocument
                                    tt = _.reject(tt, val)
                                    this.setState({ finacialdocument: tt })
                                }}
                                icon="delete"
                                size={'small'}
                            />
                        </Tooltip>
                    </React.Fragment>
                )
            }

        ]


        return (
            <Form onSubmit={this.handleSubmit} style={{ marginTop: 8 }}>
                <table className={styles.table}>
                    <thead>
                        <tr>
                            <td>Sponsor's Name</td>
                            <td>Relationship</td>
                            <td>Bank/Financial Institution</td>
                            <td>Bank's Phone No</td>
                            <td>Account Type</td>
                            <td>Account No</td>
                            <td>Balance (Rs.)</td>
                            {/* <td>Balance ($)</td> */}
                            <td>Annual Income(Rs.)</td>
                            {/* <td>Annual Income($)</td> */}
                            <td>Action</td>
                        </tr>
                    </thead>
                    <tbody>

                        <tr>
                            <td><Form.Item> {getFieldDecorator('sponser', { rules: [{ required: true }] })(
                                <Input />)}</Form.Item></td>
                            <td><Form.Item> {getFieldDecorator('relationship', { rules: [{ required: true }] })(
                                <Input />)}</Form.Item>
                            </td>
                            <td><Form.Item> {getFieldDecorator('bank', { rules: [{ required: true }] })(<Input />)}</Form.Item>
                            </td>
                            <td><Form.Item> {getFieldDecorator('bankPhone')(<Input />)}</Form.Item></td>
                            <td><Form.Item> {getFieldDecorator('acType', { rules: [{ required: true }] })(<Input />)}</Form.Item>
                            </td>
                            <td><Form.Item> {getFieldDecorator('acNo', { rules: [{ required: true }] })(<Input />)}</Form.Item>
                            </td>
                            <td><Form.Item> {getFieldDecorator('balanceRs', { rules: [{ required: true }] })(
                                <InputNumber onChange={(balanceRs) => {
                                    setFieldsValue({ balanceRs, balanceDollar: Math.round(balanceRs / currencyValue) })
                                    this.setState({
                                        balanceDollar: Math.round(balanceRs / currencyValue)
                                    })
                                }} />)}</Form.Item></td>
                            <td><Form.Item>{getFieldDecorator('balanceDollar')(<Input disabled={true} />)}</Form.Item></td>
                            <td><Form.Item> {getFieldDecorator('annualRs', { rules: [{ required: true }] })(<InputNumber
                                onChange={(annualRs) => {
                                    setFieldsValue({ annualRs, annualDollar: Math.round(annualRs / currencyValue) })
                                    this.setState({
                                        annualDollar: Math.round(annualRs / currencyValue)
                                    })
                                }} />)}</Form.Item>
                            </td>
                            <td>
                                <Form.Item>
                                    {getFieldDecorator('annualDollar')(<Input disabled={true} />)}
                                </Form.Item>
                            </td>
                            <td>
                                <Button type={'dashed'}
                                    htmlType={'submit'}
                                    icon={'plus-circle'}
                                />
                            </td>
                        </tr>

                        {/*<React.Fragment>*/}
                        {/*{finacialGrid.map((val, key) => {*/}
                        {/*return <tr key={key}>*/}
                        {/*<td>{val.sponser}</td>*/}
                        {/*<td>{val.relationship}</td>*/}
                        {/*<td>{val.bank}</td>*/}
                        {/*<td>{val.bankPhone}</td>*/}
                        {/*<td>{val.acType}</td>*/}
                        {/*<td>{val.acNo}</td>*/}
                        {/*<td>{val.balanceRs}</td>*/}
                        {/*<td>{val.balanceDollar}</td>*/}
                        {/*<td>{val.annualRs}</td>*/}
                        {/*<td>{val.annualDollar}</td>*/}
                        {/*</tr>*/}
                        {/*})}*/}
                        {/*</React.Fragment>*/}

                    </tbody>

                </table>
                {this.state && this.state.finacialdocument && this.state.finacialdocument.length !== 0 &&
                    <Table
                        size={'small'}
                        pagination={false}
                        bordered={true}
                        columns={tableColumns}
                        dataSource={this.state.finacialdocument}
                    />
                }

                <Button
                    type={'primary'}
                    icon={'save'}
                    style={{ marginTop: '10px' }}
                    onClick={() => {
                        this.save()
                    }}>Save Financial Grid </Button>

            </Form>
        )
    }
}

@Form.create()
class AddFamilyAndFinance extends PureComponent {
    state = {
        id: '',
        count: 0,
        currencyValue: 1,
        showFirst: true,
        finacialGrid: [],
        allow: true
    }

    handleSubmit1 = e => {
        const { dispatch, form } = this.props

        e.preventDefault()

        form.validateFieldsAndScroll(async (err, valData) => {
            if (!err) {
                let values = _.clone(valData)

                let draftObj = {
                    _id: this.state.inquiryId,
                    draft: { ...values }
                }


                let x = await Request.addFamilyAndFinance({ ...draftObj })


                dispatch(hideLoader())

                if (!x.error) {
                    notification.success({
                        message: 'Success',
                        description: x.msg
                    })

                    // this.props.form.resetFields()
                } else {
                    notification.error({
                        message: 'Error Saving',
                        description: x.msg
                    })
                }
            }
        })
    }

    constructor(props) {
        super(props)
        this.table = React.createRef()
    }

    apiRequest = (params, columns) => {
        return new Promise(async resolve => {
            if (!params.sortField) {
                params.sortField = 'id'
                params.sortOrder = 'descend'
            }
        })
    }

    refreshFxn = () => {
        this.setState({ refreshChild: !this.state.refreshChild })
    }

    async componentDidMount() {
        let searchParams = new URLSearchParams(this.props.search)

        let inquiryId = searchParams.get('id')
        this.setState({ inquiryId: inquiryId }, () => {

        })

        let { doc, allow } = await Request.getInquiry(inquiryId)

        if (doc && allow) {

            this.setState({ completeInfo: doc })

            let { draft } = doc
            if (draft) {

                setTimeout(() => {
                    this.props.form.setFieldsValue({
                        amountOfTutionFee: draft.amountOfTutionFee,
                        bankName: draft && draft.bankName,
                        draftAmount: draft.draftAmount,
                        draftDate: moment(draft.draftDate),
                        institute: draft.institute,
                        balance: draft && draft.balance,
                    })
                }, 1000)


            }

            let { form } = this.props
        } else {
            this.setState({ allow: false })
        }


    }

    render() {
        const { finacialGrid, inquiryId, currencyValue, completeInfo, allow } = this.state
        const {
            form: { getFieldDecorator, getFieldValue, setFieldsValue }, show
        } = this.props

        let MyWrapper = DIV

        if (!show) {
            MyWrapper = PageHeaderWrapper
        }


        return (
            allow ?
                <MyWrapper title={'Family And Finance'}>

                    {
                        (completeInfo && !show) ? < div style={{ marginBottom: 10 }}>
                            <StudentHeader
                                info={this.state.inquiryId}
                                data={completeInfo}
                                dispatch={this.props.dispatch}
                            />
                        </div> : null
                    }

                    {
                        (completeInfo && !show) ? <Card bordered={true} style={{ marginBottom: 10 }}>
                            <StudentInfo
                                info={completeInfo}
                            />
                        </Card> : null
                    }

                    {
                        completeInfo ?

                            <Card bordered={false}>
                                <Tabs type="card">

                                    <TabPane tab={`Family And Finance`} key={'0'} forceRender={true}>
                                        {inquiryId && <FormComp handleSubmit={this.handleSubmit}
                                            getCurrenyValue={(currencyValue) => {
                                                this.setState({
                                                    currencyValue
                                                })
                                            }}
                                            loading={this.props.loading}
                                            inquiryId={this.state.inquiryId} />}

                                        <Card bordered={true} title={'Financial Grid'}>

                                            <GridForm inquiryId={inquiryId}
                                                finacialGrid={finacialGrid}
                                                currencyValue={currencyValue}

                                            />

                                        </Card>

                                    </TabPane>

                                    <TabPane tab={`Add Tution Fee`} key={'1'} forceRender={true}>
                                        <Form onSubmit={this.handleSubmit1} style={{ marginTop: 8 }}>
                                            <div>
                                                <Row>
                                                    <Col span={12}>
                                                        <GetAllFormFields
                                                            inputSchema={tutionFields}
                                                            refresh={this.refreshFxn}
                                                            getFieldDecorator={getFieldDecorator}
                                                        />
                                                    </Col>

                                                </Row>
                                            </div>
                                            <Button
                                                type="primary"
                                                htmlType="submit"
                                                style={{
                                                    marginBottom: 10,
                                                    marginLeft: '33%',
                                                    backgroundColor: 'green'
                                                }}
                                                loading={this.props.loading}>
                                                Save Financial Details
                                            </Button>
                                        </Form>
                                    </TabPane>

                                </Tabs>
                            </Card>
                            : null
                    }


                </MyWrapper> : <Exception />
        )
    }
}

const mapStateToProps = ({ global, router }) => ({
    loading: global.buttonLoading,
    categories: global.categories,
    search: router.location.search,
    pathname: router.location.pathname
})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AddFamilyAndFinance)
